"use strict";
// Defines the types of handicap adjustments that can be made
Object.defineProperty(exports, "__esModule", { value: true });
